import { ScheduledTask, ScheduledTaskApi, UnscheduledTask, UnscheduledTaskApi } from '../services/schedule.types'
import { ValueListEntry } from '../../../../utils/types/global.types'

/**
 * Convert UnscheduledTaskApi to UnscheduledTask objet
 * @param typeTacheList
 * @param content
 */
export const mapUnscheduledTaskApiToApp = (typeTacheList: ValueListEntry[], content: UnscheduledTaskApi[]): UnscheduledTask[] => {
	return content.map((c: UnscheduledTaskApi) => {
		const tache = typeTacheList.find((t) => t.code === c.type)
		return ({
			...c,
			resource: c.resources,
			title: tache?.label || ''
		})
	})
}

/**
 * Convert ScheduledTaskApi to ScheduledTask objet
 * @param typeTacheList
 * @param content
 */
export const mapScheduledTaskApiToApp = (typeTacheList: ValueListEntry[], content: ScheduledTaskApi[]): ScheduledTask[] => {
	return content.map((c: ScheduledTaskApi) => {
		const tache = typeTacheList.find((t) => t.code === c.type)
		return ({
			...c,
			resource: c.resources,
			title: tache?.label || ''
		})
	})
}

/**
 * Format ressource label to selector filter in mobiscroll modal
 * @param ressourceLabel
 */
export const formatChipLabelRessource = (ressourceLabel: string): string => {
	const labelSplit = ressourceLabel.split(' ')
	return labelSplit.map(split => split.slice(0, 1)).join('')
}